import {
  ITooltipHostStyles,
  mergeStyleSets,
  TooltipHost,
  TooltipOverflowMode,
} from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";

const classes = mergeStyleSets({
  formerClient: {
    textDecoration: "line-through",
  },
  overflow: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const hostStyles: Partial<ITooltipHostStyles> = {
  root: { display: "block" },
};

type Props = {
  clientName: string;
  webBasePartnerNumber: string;
  isFormerClient?: boolean;
};

const ClientName = ({
  clientName,
  webBasePartnerNumber,
  isFormerClient,
}: Props) => {
  const { t } = useTranslation();
  const displayText = `${clientName} (${webBasePartnerNumber})`;
  const tooltipContent = isFormerClient
    ? `${displayText} - ${t("bfm.formerClient.tooltip")}`
    : displayText;

  return (
    <TooltipHost
      content={tooltipContent}
      overflowMode={isFormerClient ? undefined : TooltipOverflowMode.Self}
      hostClassName={classes.overflow}
      styles={hostStyles}
    >
      <span className={isFormerClient ? classes.formerClient : undefined}>
        {displayText}
      </span>
    </TooltipHost>
  );
};

export default ClientName;
